module.exports = __webpack_public_path__ + "static/media/progress-done.df068944.svg";